<script lang="ts">
const __DsBlock = {
	hidden: true,
	options: [
		{
			name: 'disabled',
		},
		{
			name: 'disabledNotice',
		},
		{
			name: 'readonly',
		},
	],
}
</script>
<script lang="ts" setup>
import type { InputBlockProps } from '~/types/input-block';
import { defineBlock } from '#layers/block-engine';
import { IconPicker, useDisabledNotice } from '#layers/ui';
import { usePrimitiveFormField } from '~/composables/form-block/use-primitive-form-field';

interface InputIconBlockProps extends InputBlockProps {
	block?: boolean;
}

const props = defineProps<InputIconBlockProps>();

const model = defineModel<string | null>();
const { disabled, disabledNotice, nullable } = usePrimitiveFormField(props, { model });
const { showDisabledNotice } = useDisabledNotice({ disabled, disabledNotice });

;
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<!-- TODO: <div> necessary because DTooltip doesn't play nice with IconPicker -->
		<div>
			<IconPicker
				v-model="model"
				:block
				:readonly
				:aria-readonly="readonly"
				:disabled
				:clear="nullable"
			/>
		</div>
	</DTooltip>
</template>
